<template>
<div style="font-size:13px;font-family: Geneva, arial, helvetica, sans-serif;">
  <div style="padding: 5px; width: 800px; height: 41px">
    <div style="margin-right: 5px; height: 30px" align="right">
      <img src="../assets/members.gif" style="width:300px; height:30px" />
    </div>
  </div>

  <div v-show="ready" style="display:flex">
    <!-- Navigation -->
    <div class="left-nav">
      <h4 style="cursor:pointer"><a href="#/member/group" style="color:black">Dokhlab</a></h4>

      <h5>Current Members</h5>
      <ul>
        <li class="mem"><a href="#/member/pi">Principal Investigator</a></li>
        <div v-for="(type,itype) in memberTypes" :key="itype">
          <folder class="mems">
            {{type}}s
            <template slot="items">
              <ul style="padding-left:28px">
                <!--
                <li class="mem" @click="member=mem" v-for="mem in filterMembers(type, 'yes')" v-text="`${mem.f_name} ${mem.l_name}`"></li>
                -->
                <li class="mem" v-for="(mem,imem) in filterMembers(type, 'yes')" :key="imem">
                  <a :href="`#/member/${mem.mem_id}`" v-text="`${mem.f_name} ${mem.l_name}`"></a>
                  <!-- <router-link :to="`/member/${mem.mem_id}`" v-text="`${mem.f_name} ${mem.l_name}`"></router-link> -->
                </li>
              </ul>
            </template>
          </folder>
        </div>
      </ul>

      <h5>Alumni</h5>
      <ul>
        <div v-for="(type,itype) in alumniTypes" :key="itype">
          <folder class="mems">
            {{type}}s
            <template slot="items">
              <ul style="padding-left:28px">
                <!--
                <li class="mem" @click="member=mem" v-for="mem in filterMembers(type, 'no')" v-text="`${mem.f_name} ${mem.l_name}`"></li>
                -->
                <li class="mem" v-for="(mem,imem) in filterMembers(type, 'no')" :key="imem"><a
                  :href="`#/member/${mem.mem_id}`" v-text="`${mem.f_name}
                ${mem.l_name}`"></a></li>
              </ul>
            </template>
          </folder>
        </div>
      </ul>
    </div>

    <!-- Member -->
    <div style="flex-direction:column;width:100%;border:1px solid #BBBBBB;padding:10px;margin-left:10px">
      <div v-show="id==='group'">
        <div style="margin:auto auto;width:468px;height:348px">
          <img style="width:100%;height:100%" :src="$store.state.host+`/dokhlab/actions/member_image?name=DG2017-bw.jpg`">
        </div>
      </div>

      <div v-show="id!=='group'&&member">
        <div style="display:flex;align-items:center;height:300px">
          <!-- Member info -->
          <div style="flex-direction:column;padding:0px 60px;min-width:20px;width:200px">
            <ul v-show="member">
              <li>Full Name: <b>{{member.f_name}} {{member.m_init}} {{member.l_name}}</b></li>
              <li>Status :   <b>{{member.designation}}</b></li>
              <li>Tenure :   <b>{{member.memfrom}} - {{member.memtill}}</b></li>
              <li v-show="mem_has(member, 'email')">E-mail :   <b>{{mem_get(member, 'email')}}</b></li>
              <li v-show="mem_has(member, 'phone')">Phone :    <b>{{mem_get(member, 'phone')}}</b></li>
            </ul>
          </div>

          <!-- Member Image -->
          <div style="flex-direction:column;max-width:135px;height:197px">
            <img class="mem-img" :src="$store.state.host+`/dokhlab/actions/member_image?name=${member.f_name}-${member.l_name}.jpg`">
          </div>
        </div>

        <div v-show="mem_has(member, 'info')">
          <h3>About {{member.f_name}}</h3>
          <div class="mem-panel">
            <p v-html="mem_get(member, 'info')"></p>
          </div>
        </div>

        <div v-show="mem_has(member, 'education')">
          <h3>Education</h3>
          <div class="mem-panel">
            <p v-html="mem_get(member, 'education')"></p>
          </div>
        </div>

        <div v-show="mem_has(member, 'awards')">
          <h3>Honors and Awards</h3>
          <div class="mem-panel">
            <p v-html="mem_get(member, 'awards')"></p>
          </div>
        </div>

        <div v-show="memPubs.length>0">
          <h3>Publications</h3>
          <div class="mem-panel">
            <ul>
              <li v-for="(publication,ipub) in memPubs" :key="ipub">
                <div style="margin-bottom:10px">
                  {{publication.originalAuthors}} "{{publication.title}}", <i>{{publication.journal}}</i>, {{(publication.fpage) ? `${publication.volume}:${publication.fpage}-${publication.lpage}` : `in press`}}, ({{publication.year}})<br>
                  <template v-if="publication.abstract">[<a style="cursor:pointer" @click="showAbstract(publication)">Abstract</a>]</template>
                  <template v-if="publication.has_pdf==='yes'">[<a target="_blank" :href="$store.state.host+'/dokhlab/actions/download?name=papers/pdf/'+publication.code+'.pdf'">PDF</a>]</template>
                  <template v-if="publication.suppinfo==='yes'">[<a target="_blank" :href="$store.state.host+'/dokhlab/actions/download?name=papers/suppl/'+publication.code+'-SuppInfo.pdf'">Supporting Information</a>]</template>
                  <template v-if="publication.news">[<a :href="publication.news" target="_blank">News</a>]</template>
                  <template v-if="publication.f1000&&publication.f1000!=='no'">[<a :href="publication.f1000" target="_blank">F1000</a>]</template>
                </div>
              </li>
            </ul>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Members',

  data () {
    return {
      publications: [],
      members: [],
      member: {},
      memPubs: [],
      ready: false
    }
  },

  computed: {
    currentPostdocs () {
      return this.members.filter(mem => mem.current === 'yes' && mem.designation === 'Postdoctoral Fellow')
    },

    memberTypes () {
      let mTypes = ['Undergraduate Student', 'Postdoctoral Fellow', 'Research Assistant Professor', 'Graduate Student', 'Technician', 'Graduate (MS) Student', 'Visiting Scientist', 'Foreign Student', 'Fullbright Foreign Student', 'Rotation Student', 'High School Student']
      return mTypes.filter(t => { return this.filterMembers(t, 'yes').length > 0 })
    },

    alumniTypes () {
      let types = ['Research Assistant Professor', 'Postdoctoral Fellow', 'Graduate Student', 'Undergraduate Student', 'Technician', 'Visiting Scientist', 'Graduate (MS) Student', 'Summer Student', 'Fullbright Foreign Student', 'Rotation Student', 'High School Student']
      return types.filter(t => { return this.filterMembers(t, 'no').length > 0 })
    }
  },

  // beforeRouteUpdate (to, from, next) {
  //   const id = to.params.id
  //   this.setMember(id)
  //   next()
  // },

  watch: {
    '$route': {
      immediate: true,
      async handler (to, from) {
        if (to.name === 'Members') {
          this.id = this.$route.params.id


          if (this.members.length === 0) {
            await this.setMembers()
          }
          if (this.publications.length === 0) {
            await this.setPubs()
          }
          this.ready = true

          this.setMember(this.id)
        }
      }
    }
  },

  methods: {
    getMember (id) {
      if (id === 'group') {
        return []
      } else if (id === 'pi') {
        return this.members.filter(mem => mem.designation === 'Principal Investigator')[0]
      } else {
        return this.members.filter(mem => `${mem.mem_id}` === id)[0]
      }
    },

    getMemPubs (id) {
      if (id === 'group') {
        return []
      } else {
        let l = this.member.l_name
        let f = this.member.f_name[0]
        let name = l + ', ' + f
        return this.publications.filter(pub => this.getProp(pub, 'authors').filter(author => author.toUpperCase().includes(name.toUpperCase())).length > 0)
      }
    },

    setMember (id) {
      if (id === 'group') {
        this.member = []
        this.memPubs = []
      } else {
        if (id === 'pi') {
          this.member = this.members.filter(mem => mem.designation === 'Principal Investigator')[0]
        } else {
          this.member = this.members.filter(mem => `${mem.mem_id}` === id)[0]
        }
        let l = this.member.l_name
        let f = this.member.f_name[0]
        let name = l + ', ' + f
        this.memPubs = this.publications.filter(pub => this.getProp(pub, 'authors').filter(author => author.toUpperCase().includes(name.toUpperCase())).length > 0)
      }
    },

    getProp (obj, key) {
      for (var k in obj) {
        if (k.toUpperCase() === key.toUpperCase()) {
          return obj[k]
        }
      }
      return ''
    },

    filterMembers (designation, current) {
      return this.members.filter(mem => mem.current === current && mem.designation === designation)
    },

    mem_has (m, p) {
      if (p in m) {
        if (!m[p] || m[p].trim() === '' || m[p].trim() === 'null') {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },

    mem_get (m, p) {
      if (p in m) {
        if (m[p]) {
          return m[p]
        } else {
          return ''
        }
      } else {
        return ''
      }
    },

    formatAuthors () {
      this.publications.forEach(pub => {
        let authors = []
        let firstName = ''
        let lastName = ''
        pub.authors.split(/and |[, ]/).forEach((name, ind) => {
          name = name.replace(/\s+/g, '')
          if (name !== '') {
            if (name[name.length - 1] === '.') {
              firstName += name
            } else {
              if (ind !== 0) {
                authors.push(`${lastName}, ${firstName}`)
                firstName = ''
                lastName = ''
              }
              lastName = name
            }
          }
        })
        authors.push(`${lastName}, ${firstName}`)
        pub.originalAuthors = pub.authors
        pub.authors = authors
      })
    },

    setPubs () {
      return axios({
        method: 'get',
        url: this.$store.state.host + '/dokhlab/actions/publications'
      }).then(response => {
        // this.publications = response.data
        this.publications.push(...response.data)
        this.publications.sort((a, b) => b.pub_id - a.pub_id)
        this.formatAuthors()
      }).catch(() => {
        alert('Fetch publications failed!')
      })
    },

    setMembers () {
      return axios({
        method: 'get',
        url: this.$store.state.host + '/dokhlab/actions/members'
      }).then(response => {
        // this.members = response.data
        this.members.push(...response.data)
      }).catch(() => {
        alert('Fetch members failed!')
      })
    }
  },

  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.introduction {
  padding: 10px 30px;
  color: #5a5e66;
  font-size: 14px;
  text-align: justify;
}

img {
  width: 50%;
}

.mem-img {
  display: block;
  width: auto;
  height: 100%;
}

.mem {
  cursor: pointer;
  font-size: 12px;
}

.mems {
  font-size: 12px;
}

.mem-panel {
  background-color:#EEEEEE;
  border:1px solid #BBBBBB;
  padding:5px 10px;
  text-align: justify;
  text-justify: inter-word;
}

.left-nav li {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.left-nav {
  flex-direction:column;
  background-color:#EEEEEE;
  border:1px solid #BBBBBB;
  padding:5px 10px;
  min-width: 200px;
}

.mem a {
  color: black;
}

</style>
